import React from 'react';
import { Box } from '@mui/material';
import FileManager from '../components/FileManager';

const Files = () => {
  return (
    <Box sx={{ p: 3 }}>
      <FileManager />
    </Box>
  );
};

export default Files;
